import { Component } from '@angular/core';
import { TeamService } from '../../../../shared/services/team.service';
import { ITeamMember } from '../../../../shared/interfaces/team.interface';
import { TeamCard } from '../team-card/team-card';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-team-card-container',
  imports: [CommonModule, TeamCard],
  templateUrl: './team-card-container.html',
  styleUrl: './team-card-container.scss'
})
export class TeamCardContainer {

  protected teamMembers: ITeamMember[] = []

  constructor(private teamService: TeamService) {
    this.teamMembers = teamService.getTeamMembers();
  }

}
